import { BaseWebComponent } from "../base-components/base-web-component.js";

export class HelpWindow extends BaseWebComponent {
    static webComponentName: string = "help-window";
    static observedAttributes: string[] = ['topic'];
    protected _templateId: string = "help-window";
    private helpWindowContent!: HTMLElement;
    private helpWindowHeader!: HTMLElement;
    private helpWindowTitle!: HTMLElement;
    private helpWindowClose!: HTMLAnchorElement;
    private helpWindowBody!: HTMLElement;
    constructor() {
        super();
        this.addEventListener('click', (event: MouseEvent) => {
            if (event.target === this) {
                this.hide(); // Close the window when clicking outside the content
            }
        });
    }
    private _content: string = '';
    get content(): string {
        return this._content;
    }
    set content(value: string) {
        this._content = value;
        this.render();
    }

    show(): void {
        this.classList.add('active');
    }
    hide(): void {
        this.classList.remove('active');
    }
    toggle(): void {
        this.classList.toggle('active');
    }
    close(): void {
        this.hide();
    }
    private renderHelpContent(): void {
        const title = this.getAttribute('title') || 'Help';
        if (this.helpWindowTitle) {
            this.helpWindowTitle.textContent = title;
        }
        if (this.content && this.helpWindowBody) {
            this.helpWindowBody.innerHTML = this.content;
            this.show();
        }
    }
    protected afterRender(): void {
        this.helpWindowContent = this.querySelector('help-window-content') as HTMLElement;
        this.helpWindowHeader = this.querySelector('help-window-header') as HTMLElement;
        this.helpWindowTitle = this.querySelector('help-window-title') as HTMLElement;
        this.helpWindowClose = this.querySelector('[help-window-close]') as HTMLAnchorElement;
        this.helpWindowBody = this.querySelector('help-window-body') as HTMLElement;
        if(this.helpWindowContent) {
            this.helpWindowContent.addEventListener('click', (event: MouseEvent) => {
                event.stopPropagation(); // Prevent click from closing the window
            });
        }
        this.setupEventListeners();
    }
    private _rendered: boolean = false;
    protected render(): void {
        if (this.content === '') {
            console.warn("HelpWindow: content is empty, nothing to render");
            return;
        }
        if (!this._rendered) {
            this._rendered = true;
            super.render();
        }
        this.renderHelpContent();
    }
    private setupEventListeners(): void {
        this.helpWindowClose.addEventListener('click', (event: MouseEvent) => {
            event.preventDefault();
            this.hide();
        });
    }

    
    static create(content: string, title: string = 'Help'): HelpWindow {
        const helpWindow = document.createElement(HelpWindow.webComponentName) as HelpWindow;
        helpWindow.setAttribute('title', title);
        document.body.appendChild(helpWindow);
        helpWindow.content = content; 
        return helpWindow;
    }
}